import React from "react";
import { useNavigate } from "react-router-dom";
import BaseFormPage from "../../components/BaseFormPage";
import BaseInput from "../../components/BaseInput";
import BaseButton from "../../components/BaseButton";
import BaseTextButton from "../../components/BaseTextButton";
import FormHeader from "../../components/FormHeader";
import "./style.scss";
import useController from "./controller";
import { useTranslation } from "react-i18next";
import ROUTES from "../../utils/routes.js";
export default function NewPasswordPage() {
  const {
    onHandlePass,
    onHandleRepeatPass,
    onSubmitHandle,
    isSamePasswords,
    pass,
    repeatPass,
    isUpdateSending,
    updateError,
  } = useController();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="pass-page-wrapper">
      <BaseFormPage
        backTo={ROUTES.RECOVERY_PAGE}
        className="pass-page-wrapper__page-wrapper"
      >
        {/* фикс 16.07: на .com заголовок/лейблы/кнопка были захардкожены по-русски */}
        <FormHeader title={t("recovery_page.new_pass")} />
        <div className="pass-page-wrapper__tip">{t("set_new_pass")}</div>
        <form onSubmit={onSubmitHandle} className="pass-page-wrapper__form">
          <BaseInput
            onChange={(event) => onHandlePass(event.target.value)}
            id="new-pass"
            value={pass}
            name="password"
            label={t("recovery_page.new_pass")}
            type="password"
          />
          <BaseInput
            onChange={(event) => onHandleRepeatPass(event.target.value)}
            id="repeat-new-pass"
            name="repeatPass"
            value={repeatPass}
            label={t("recovery_page.approve_new_pass")}
            type="password"
            errorMessage={!isSamePasswords ? t("register_page.same_pass") : ""}
          />
          <BaseButton
            className="pass-page-wrapper__btn-save"
            type="submit"
            disabled={isUpdateSending || !isSamePasswords || !pass}
            loading={isUpdateSending}
          >
            {t("save")}
          </BaseButton>
          {updateError ? (
            <div className="pass-page-wrapper__error">
              {t("new_password_page.save_error")}
            </div>
          ) : null}
        </form>
        {/* Доработка 15.07: явный выход в поддержку, если сохранить не удаётся
           (протухший 10-минутный код восстановления и т.п.). Вне <form>:
           BaseTextButton рендерит <button type="text"> → браузер трактует как
           submit, и внутри формы клик мог бы отправить смену пароля */}
        <BaseTextButton
          className="pass-page-wrapper__support"
          onClick={() => navigate(ROUTES.SUPPORT_PAGE)}
        >
          {t("support_btn")}
        </BaseTextButton>
      </BaseFormPage>
    </div>
  );
}
